import * as React from 'react';
import { format } from 'date-fns';
import { faBoxOpen } from '@fortawesome/pro-regular-svg-icons';

import { IIndexedOrder } from 'src/graphql/types';
import { Template } from '../Template';

interface Props {
  item: IIndexedOrder;
}

export const Order = ({ item }: Props) => {
  const title = (
    <div className="d-flex flex-row justify-content-between w-100">
      <span>Order #{item.id}</span>
      <span>{format(new Date(item.completedAt), 'MMM d, y')}</span>
    </div>
  );

  return (
    <Template icon={faBoxOpen} title={title}>
      <div className="mb-2">
        <strong>Purchaser: </strong>
        {item.purchaserName && <div className="text-truncate">{item.purchaserName}</div>}
        {item.purchaserEmail && <div className="text-truncate">{item.purchaserEmail}</div>}
        {item.purchaserPhone && <div className="text-truncate">{item.purchaserPhone}</div>}
      </div>

      <div className="mb-2">
        <strong>Recipient: </strong>
        {item.deliveryName && <div className="text-truncate">{item.deliveryName}</div>}
        {item.deliveryAddress && <div className="text-truncate">{item.deliveryAddress}</div>}
      </div>

      <div className="mb-2">
        <strong>Merchants: </strong>
        <div className="text-truncate">{item.merchantNames.join(', ')}</div>
      </div>
    </Template>
  );
};
